import { BtnVoltarAtv03 } from "../../components/BtnVoltar";

export default function Atividade13() {
    return (
        <>
            <h1>Hedy Lamarr's Todos</h1>
            <img 
                src="https://i.imgur.com/yXOvdOSs.jpg"
                alt="Hedy Lamarr"
                className="photo"
            />
            <ul>
                <li>Invent new traffic lights</li>
                <li>Rehearse a movie scene</li>
                <li>Improve the spectrum technology</li>
            </ul>
            <br />
            <BtnVoltarAtv03 />
        </>
    );
}